import React, {Component} from 'react';
import "./AboutSketch.scss"
import SketchImg01 from "../../static/img/sketch-01.jpg"
import SketchImg02 from "../../static/img/sketch-02.jpg"
import SketchImg03 from "../../static/img/sketch-03.jpg"
import SketchImg04 from "../../static/img/sketch-04.jpg"

class AboutSketch extends Component {
    render() {
        let {qrcodeImg}=this.props;
        return (
            <div className="sketch">
                <div className="sketch-tips">
                    <div className="title">
                        为什么需要我们
                    </div>
                    <div className="text">
                        传统物流行业效率低、管理手段落后，导致物流成本长期居高不下。空载率高、信息不透明、交易效率低， 造成了物流市场上大量的资源浪费。
                    </div>
                </div>
                <div className="sketch-list">
                    <div className="one">
                        <div className="title">
                            网络货运平台
                        </div>
                        <div className="text">
                        宜兴交运运用互联网与大数据技术，为传统物流业装上智慧大脑。为司机、货主提供一站式在线交易服务的优质网络货运平台。可根据车辆位置、车型、车况精准调度，为运输计划提供车货匹配服务。对运输车辆进行实时跟踪，提供完善的方案，确保运力充足可靠。并提供在线结算、支付和开具运输发票，支持银联、微信、支付宝等多种支付方式。
                        </div>
                        <div className="bottom">
                            <div class="top-section big-screen">
                                <button onClick={ e => {window.open('./big-screen.html')}}>进入大屏</button>
                            </div>
                            <div class="bottom-section">
                                <div className="download">
                                    扫码下载
                                </div>
                                <div className="icon">
                                    <img src={qrcodeImg} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="icon">
                            <img src={SketchImg01} alt=""/>
                        </div>
                        <div className="title">
                            货主端
                        </div>
                        <div className="text">
                            适用:<br/>
                            厂商、货主、货站、物流公司等平台托运方
                        </div>
                        <div className="explain">
                            托运人将托运订单发送到平台等待车主接单，交易成功后，可在线支付运费、在线跟踪货物运输状态以及获得平台开具增值税发票
                        </div>
                    </div>
                    <div className="item">
                        <div className="icon">
                            <img src={SketchImg02} alt=""/>
                        </div>
                        <div className="title">
                            司机端
                        </div>
                        <div className="text">
                            适用:<br/>
                            物流公司、车队、车主、司机等平台承运人
                        </div>
                        <div className="explain">
                            承运人可在线查找自己需要的货源，进行抢单承运。交易成功后，可以在线收取运费;
                        </div>
                    </div>
                </div>
                <div className="sketch-img">
                    <img src={SketchImg03} alt=""/>
                    <img src={SketchImg04} alt=""/>
                </div>
            </div>
        );
    }
}

export default AboutSketch;
